var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.theme.stepperLabel
  }, [(_vm.step !== undefined) ? _c('span', {
    class: _vm.theme.step
  }, [_vm._v(_vm._s(_vm.step))]) : (_vm.icon !== undefined) ? _c('span', {
    class: _vm.theme.icon
  }, [_c('v-font-icon', {
    attrs: {
      "danger": _vm.danger
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._t("default")], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744cbc01","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Stepper/StepperLabel.vue
// module id = 704
// module chunks = 0